export const API_HOST = <string>process.env.REACT_APP_API_HOST; //"https://api.rechtsportal24.de"
export const API_PATH = "";
export const MERCURE_URL = <string>process.env.REACT_APP_MERCURE_URL;
export const MERCURE_PREFIX = <string>process.env.REACT_APP_MERCURE_PREFIX;
export const ALGOLIA_SEARCH_API_KEY = process.env.REACT_APP_ALGOLIA_SEARCH_API_KEY || "";
export const ALGOLIA_APPLICATION_ID = process.env.REACT_APP_ALGOLIA_APPLICATION_ID || "";
export const ALGOLIA_ORGANIZATION_INDEX = process.env.REACT_APP_ALGOLIA_ORGANIZATION_INDEX || "";
